class AlbumPhotoViewer {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.viewer = document.getElementById(`album-photo-viewer-${sectionId}`);
    this.viewerImage = this.viewer.querySelector('.album-viewer-image');
    this.closeBtn = this.viewer.querySelector('.album-viewer-close');
    this.prevBtn = this.viewer.querySelector('.album-viewer-prev');
    this.nextBtn = this.viewer.querySelector('.album-viewer-next');
    
    this.images = [];
    this.currentIndex = 0;
    
    this.init();
  }

  init() {
    // Collect all album images for this section
    const albumImages = document.querySelectorAll(`[data-album-image][data-section-id="${this.sectionId}"]`);
    
    albumImages.forEach((img, index) => {
      this.images.push({
        url: img.dataset.fullImage,
        alt: img.dataset.imageAlt || '',
        element: img
      });

      // Add click event to open viewer
      img.addEventListener('click', () => {
        this.open(index);
      });
    });

    // Add event listeners for controls
    this.closeBtn.addEventListener('click', () => this.close());
    this.prevBtn.addEventListener('click', () => this.prev());
    this.nextBtn.addEventListener('click', () => this.next());

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (this.viewer.style.display !== 'none') {
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.prev();
        if (e.key === 'ArrowRight') this.next();
      }
    });

    // Click outside to close
    this.viewer.addEventListener('click', (e) => {
      if (e.target === this.viewer) {
        this.close();
      }
    });
  }

  open(index) {
    this.currentIndex = index;
    this.updateImage();
    this.viewer.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.viewer.style.display = 'none';
    document.body.style.overflow = '';
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    this.updateImage();
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    this.updateImage();
  }

  updateImage() {
    const currentImage = this.images[this.currentIndex];
    this.viewerImage.src = currentImage.url;
    this.viewerImage.alt = currentImage.alt;

    // Update button states
    if (this.images.length === 1) {
      this.prevBtn.style.display = 'none';
      this.nextBtn.style.display = 'none';
    } else {
      this.prevBtn.style.display = 'block';
      this.nextBtn.style.display = 'block';
    }
  }
}

// Initialize viewers for all album sections
document.addEventListener('DOMContentLoaded', () => {
  const albumSections = document.querySelectorAll('[data-album-image]');
  const sectionIds = new Set();
  
  albumSections.forEach(img => {
    sectionIds.add(img.dataset.sectionId);
  });

  sectionIds.forEach(sectionId => {
    new AlbumPhotoViewer(sectionId);
  });
});
